import React, {useState} from 'react';
import {
  DocCard,
  CardBoldText,
  CardContainer,
} from 'app/src/elements';
import { Text, Pressable, Image } from 'react-native';
import { useMutation } from '@apollo/client';
import { REMOVE_ATTACHMENT } from '../components/Attachments/queries';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquareXmark } from '@fortawesome/free-solid-svg-icons';
import { elRed } from 'app/src/styles/colors';
import { DocumentsContainer, NameColumn, XColumn } from '../components/Attachments/elements';
import { Link } from 'app/src/utils/routing';

const DocumentCard = props => {
  const { attachment, updateAttachments } = props;

  const [removeAttachment] = useMutation(REMOVE_ATTACHMENT, {
    onCompleted: (response) => {
      updateAttachments(
        'Document',
        'remove',
        response.removeAttachment.attachment
      )
    }
  });

  const onRemove = () => {
    removeAttachment({ variables: {id: attachment.id} });
  }

  return (
    <CardContainer>
      <DocCard>
        <DocumentsContainer>
          <NameColumn>
            <Link to={attachment.url} target="_blank">
              <Text>{attachment.filename}</Text>
            </Link>
          </NameColumn>
          <XColumn>
            <Pressable
              style={{
                marginBottom: '0px',
                marginRight: '2px',
                zIndex: 9999999,
                alignSelf: 'flex-end',
              }}
              onPress={() => {
                if(window.confirm('Remove Document?')) {
                  onRemove();
                }
              }}
            >
              <FontAwesomeIcon
                icon={faSquareXmark}
                size='xl'
                style={{color: elRed}}
              />
            </Pressable>
          </XColumn>
        </DocumentsContainer>
      </DocCard>
    </CardContainer>
  )
}

export default DocumentCard;
